<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    List Blast List
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <!-- <a v-on:click="toggleModal('filter_export')" class="btn px-15 btn-secondary text-white"
                                style="display: inline-flex; margin: 5px">
                                <i class="fas fa-download fs-16"></i>
                                Export Blast List
                            </a>
                            <download-csv ref="exportBlastList" :data="exportJson" name="starsender_blast_list.csv"
                                style="display: none"></download-csv>
                            <a v-on:click="toggleModal('action_blast_list')" class="btn px-15 btn-danger text-white"
                                style="display: inline-flex; margin: 5px">
                                Hapus Blast List
                            </a>
                            <router-link to="/blast-list/create" class="btn px-15 btn-primary text-white"
                                style="display: inline-flex; margin: 5px">
                                <i class="fas fa-plus fs-16"></i>
                                Tambah Blast List
                            </router-link> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <BlastListTable />
                    </div>
                </div>
            </div>
            <modal name="action_blast_list" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <Action />
                </div>
            </modal>
            <modal name="filter_export" :height="'auto'" :adaptive="true" :scrollable="true"  >
                <div style="margin: 50px">
                    <FilterExport />
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import BlastListTable from "@/components/tables/BlastList.vue";
    import Action from "@/components/forms/blast_list/Action.vue";
    import FilterExport from "@/components/forms/blast_list/FilterExport.vue";
    import moment from 'moment'

    export default {
        components: {
            BlastListTable,
            Action,
            FilterExport
        },
        data() {
            return {
                group_dropdown: [],
                exportJson: []
            };
        },
        beforeDestroy(){
            this.$root.$off("toggle_modal", this.fnToggleModal);
        },
        mounted() {
            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);
        },
        methods: {
            async loadGroups() {
                try {
                    let response = await this.$store.dispatch('group_list_dropdown')
                    this.group_dropdown = response.data.data.groups
                } catch (err) {
                    this.$toast.error("Server error")
                }
            },
            async exportBlastList() {
                try {
                    this.$toast.info("Mohon Tunggu...");

                    await this.$store.dispatch('blast_list_export')
                        .then((response) => {
                            this.exportJson = response.data.data.blast_lists

                            for (let i = 0; i < this.exportJson.length; i++) {
                                this.exportJson[i].created_at = moment.utc(this.exportJson[i].created_at).local().format("YYYY-MM-DD HH:mm:ss")
                                this.exportJson[i].updated_at = moment.utc(this.exportJson[i].updated_at).local().format("YYYY-MM-DD HH:mm:ss")
                            }
                        })
                        .then(() => {
                            this.$refs.exportBlastList.$el.click()
                        })
                } catch (err) {
                    this.$toast.error(err);
                }
            },
            fillVar(val) {
                return val
            },
            toggleModal(param) {
                if (this.group_dropdown.length == 0) this.loadGroups()

                this.$modal.toggle(param);
            },
        },
    };
</script>

